import { Timestamp } from "firebase/firestore";
import { rezoneMomentDateTime } from "../../../utils";

export const buildValuesPayload = (values) => {
  const addressFields = [
    "placeName",
    "addressLine1",
    "addressLine2",
    "city",
    "state",
    "zipcode",
    "addressTimezone",
  ];

  let newValues = { ...values };

  const { startsAtDate, startsAtTime, endsAtDate, endsAtTime, timezone } =
    newValues;
  const timeValues = {
    startsAt: Timestamp.fromDate(
      rezoneMomentDateTime(startsAtDate, startsAtTime, timezone).toDate(),
    ),
    endsAt: Timestamp.fromDate(
      rezoneMomentDateTime(endsAtDate, endsAtTime, timezone).toDate(),
    ),
  };
  delete newValues.startsAtDate;
  delete newValues.startsAtTime;
  delete newValues.endsAtDate;
  delete newValues.endsAtTime;
  delete newValues.trackingPixelId;
  delete newValues.trackingPixelIds;
  newValues = { ...newValues, ...timeValues };

  const address = addressFields.reduce((acc, addressField) => {
    const value = newValues[addressField];
    delete newValues[addressField];
    return {
      ...acc,
      [addressField]: value || "",
    };
  }, {});

  const sanitizedPerformers = (newValues.performers || [])
    .filter((p) => p && p.performerId)
    .map((performer, index) => ({
      performerId: performer.performerId,
      name: performer.name ?? "",
      email: performer.email ?? "",
      links: Array.isArray(performer.links) ? performer.links : [],
      bio: performer.bio ?? "",
      credits: performer.credits ?? "",
      headshotUrl: performer.headshotUrl ?? "",
      order: performer.order ?? index,
      isHeadliner: performer.isHeadliner ?? false,
    }));
  const performerIds = sanitizedPerformers.map((p) => p.performerId);

  const valuesPayload = {
    ...newValues,
    address,
    performers: sanitizedPerformers,
    performerIds,
  };

  return Object.keys(valuesPayload).reduce((acc, key) => {
    const _acc = acc;
    if (valuesPayload[key] !== undefined) _acc[key] = valuesPayload[key];
    return _acc;
  }, {});
};
